const SummaryStat = ({ active = false, label, value }) => (
  <div
    className={`rounded-[18px] border px-3 py-2.5 shadow-[0_8px_20px_rgba(15,23,42,0.05)] transition ${
      active
        ? 'border-accent2 bg-accent2 shadow-[0_10px_24px_rgba(28,178,175,0.18)]'
        : 'border-slate-200 bg-white'
    }`}
  >
    <p
      className={`text-[9px] font-semibold uppercase tracking-[0.12em] ${
        active ? 'text-white/85' : 'text-slate-500'
      }`}
    >
      {label}
    </p>
    <p className={`mt-1 text-[1.65rem] font-bold leading-none ${active ? 'text-white' : 'text-slate-900'}`}>
      {value}
    </p>
  </div>
)

export default SummaryStat
